<template>
  <v-card-text class="inserted-values px-9 pt-3">
    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Specifikace technické změny</h4>
      </v-col>
      <v-col
        cols="12"
        v-if="individualConnectionAgreementLv.changeType === 'CONNECTION_OF_NEW_APPLIENCES'"
        class="pt-2 black--text request-value"
      >
        Připojení nových spotřebičů ve stávajícím odběrném místě
      </v-col>
      <v-col
        cols="12"
        v-if="individualConnectionAgreementLv.changeType === 'CIRCUIT_BRAKER_VALUE_CHANGE'"
        class="pt-2 black--text request-value"
      >
        Změna jmenovité proudové hodnoty hlavního jističe před elektroměrem
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Kontaktní informace žadatele</h4>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          Telefon
        </div>
        <div class="pt-2 black--text request-value">
          {{
            formatPhoneNumber(individualConnectionAgreementLv.contactDetails.phone) ||
              missingValueString
          }}
        </div>
      </v-col>
      <v-col cols="auto" md="4">
        <div class="request-label">
          E-mail
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementLv.contactDetails.email || missingValueString }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Město
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementLv.contactDetails.city || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Ulice
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementLv.contactDetails.street || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Číslo popisné
        </div>
        <div class="pt-2 black--text request-value">
          {{
            individualConnectionAgreementLv.contactDetails.landRegistryNumber || missingValueString
          }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Číslo orientační
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementLv.contactDetails.houseNumber || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          PSČ
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementLv.contactDetails.postCode || missingValueString }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        v-if="individualConnectionAgreementLv.contactDetails.addressIsTheSameAsInstallationAddress"
        class="pt-2 black--text request-value"
      >
        Adresa je stejná s adresou odběrného místa
      </v-col>
      <v-col
        cols="12"
        v-if="!individualConnectionAgreementLv.contactDetails.addressIsTheSameAsInstallationAddress"
        class="pt-2 black--text request-value"
      >
        Adresa se liší s adresou odběrného místa
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Typ objektu</h4>
      </v-col>
      <v-col cols="auto" md="3" class="pt-2 black--text request-value">
        <div v-if="individualConnectionAgreementLv.objectType === 'FAMILY_HOUSE'">
          Rodinný dům
        </div>
        <div v-if="individualConnectionAgreementLv.objectType === 'FLAT'">
          Byt
        </div>
        <div v-if="individualConnectionAgreementLv.objectType === 'RECREATION_OBJECT'">
          Rekreační objekt
        </div>
        <div v-if="individualConnectionAgreementLv.objectType === 'OFFICES'">
          Provozovna/kancelář
        </div>
        <div v-if="individualConnectionAgreementLv.objectType === 'CONSTRUCTION'">
          Stavba
        </div>
        <div v-else-if="individualConnectionAgreementLv.objectType === 'OTHER'">
          Jiné - {{ individualConnectionAgreementLv.otherObjectTypeDescription }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Údaje o odběrném místě</h4>
      </v-col>
      <v-col cols="auto" md="5">
        <div class="pt-2 black--text request-value">
          Elektrické vytápění
        </div>
        <v-row>
          <v-col cols="auto" md="4" class="pr-md-0">
            <div class="request-label">
              Akumulační
            </div>
            <div class="pt-2 black--text request-value">
              {{
                individualConnectionAgreementLv.supplyPointDetails.storageElectricHeating ||
                  missingValueString
              }}
              kW
            </div>
          </v-col>
          <v-col cols="auto" md="4" class="pr-md-0">
            <div class="request-label">
              Přímotopné
            </div>
            <div class="pt-2 black--text request-value">
              {{
                individualConnectionAgreementLv.supplyPointDetails.directElectricHeating ||
                  missingValueString
              }}
              kW
            </div>
          </v-col>
          <v-col cols="auto" md="4" class="pr-md-0">
            <div class="request-label">
              Tepelné čerpadlo
            </div>
            <div class="pt-2 black--text request-value">
              {{
                individualConnectionAgreementLv.supplyPointDetails.heatPumpElectricHeating ||
                  missingValueString
              }}
              kW
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="auto" md="4">
        <div class="pt-2 black--text request-value">
          Ohřev vody
        </div>
        <v-row>
          <v-col cols="auto" md="6" class="pr-md-0">
            <div class="request-label">
              Akumulační (bojler)
            </div>
            <div class="pt-2 black--text request-value">
              {{
                individualConnectionAgreementLv.supplyPointDetails.storageWaterHeating ||
                  missingValueString
              }}
              kW
            </div>
          </v-col>
          <v-col cols="auto" md="6" class="pr-md-0">
            <div class="request-label">
              Přímotopné
            </div>
            <div class="pt-2 black--text request-value">
              {{
                individualConnectionAgreementLv.supplyPointDetails.directWaterHeating ||
                  missingValueString
              }}
              kW
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="pt-2 black--text request-value">
          Elektromobilita
        </div>
        <v-row>
          <v-col cols="12" class="pr-md-0">
            <div class="request-label">
              Příkon dobíjecí stanice
            </div>
            <div class="pt-2 black--text request-value">
              {{
                individualConnectionAgreementLv.supplyPointDetails.chargingStationPower ||
                  missingValueString
              }}
              kW
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="pt-2 black--text request-value">
          Ostatní spotřebiče
        </div>
        <v-row>
          <div class="pt-3 pl-3 pr-3 pr-md-0">
            <div class="request-label">
              Motory 3x4100/230 V (nad 5 kW)
            </div>
            <div class="pt-2 black--text request-value">
              {{
                individualConnectionAgreementLv.supplyPointDetails.engines || missingValueString
              }}
              kW
            </div>
          </div>
          <div class="pt-3 pl-3 pr-3 pl-md-9 pr-md-0">
            <div class="request-label">
              Klimatizace
            </div>
            <div class="pt-2 black--text request-value">
              {{
                individualConnectionAgreementLv.supplyPointDetails.airConditioning ||
                  missingValueString
              }}
              kW
            </div>
          </div>
          <div class="pt-3 pl-3 pr-3 pl-md-7 pr-md-0">
            <div class="request-label">
              Světla, sporáky, jiné
            </div>
            <div class="pt-2 black--text request-value">
              {{
                individualConnectionAgreementLv.supplyPointDetails.lightsStovesOthers ||
                  missingValueString
              }}
              kW
            </div>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Proudová hodnota hl. jističe (před elektroměrem)</h4>
      </v-col>

      <v-col cols="auto" md="2">
        <div class="request-label">
          Počet fází
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementLv.circuitBreakerPhaseNumber || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          Požadovaná hodnota jističe
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementLv.circuitBreakerValue || missingValueString }} A
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          Číslo elektroměru
        </div>
        <div class="pt-2 black--text request-value">
          {{
            individualConnectionAgreementLv.supplyPointDetails.deviceSerialNumber ||
              missingValueString
          }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Náhradní zdroj</h4>
      </v-col>
      <v-col
        cols="auto"
        md="3"
        class="pt-2 black--text request-value"
        v-if="individualConnectionAgreementLv.alternativeSource === false"
      >
        NE
      </v-col>
      <v-col cols="auto" md="2" v-if="individualConnectionAgreementLv.alternativeSource === true">
        <div class="request-label">
          Výkon
        </div>
        <div class="pt-2 black--text request-value">
          {{
            individualConnectionAgreementLv.alternativeSourceDetails.power || missingValueString
          }}
          kW
        </div>
      </v-col>
      <v-col cols="auto" md="2" v-if="individualConnectionAgreementLv.alternativeSource === true">
        <div class="request-label">
          Typ
        </div>
        <div class="pt-2 black--text request-value">
          {{ individualConnectionAgreementLv.alternativeSourceDetails.type || missingValueString }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Poznámka</h4>
      </v-col>
      <v-col cols="12" class="pt-2 black--text request-value">
        {{ individualConnectionAgreementLv.note || missingValueString }}
      </v-col>
    </v-row>
    <v-row v-if="individualConnectionAgreementLv.attachment !== null">
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Příloha</h4>
      </v-col>
      <v-col cols="12" class="pt-2 request-value">
        <a @click.prevent="fileDownloadLvAgreement($event, 'attachment')">
          {{ individualConnectionAgreementLv.attachment.name }}
        </a>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Plná moc</h4>
      </v-col>
      <v-col cols="12" class="pt-2 request-value">
        <a @click.prevent="fileDownloadLvAgreement($event, 'powerOfAttorney')">
          {{ individualConnectionAgreementLv.powerOfAttorney.name }}
        </a>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { downloadFile } from '@/components/mixins/downloadFile';
import { formatPhoneNumber } from '@/components/mixins/formatPhoneNumber';

export default {
  name: 'RequestNNInsertedValues',
  mixins: [downloadFile, formatPhoneNumber],
  props: {
    individualConnectionAgreementLv: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    fileDownloadLvAgreement(event, type) {
      this.downloadFile(event, `requests/files/${this.individualConnectionAgreementLv[type].uuid}`);
    },
  },
};
</script>
